import { getPageConfig as webxGetPageConfig, getEnvInfo } from '@didi/webx-js'
import { getUrlParams, setPubData, getFpUid } from '../../../utils.js'
import { addAbTestParams } from '../../../trackEvent/index'
// import { invokeEvent } from '../index'

let pageData = null
export const getPageConfig = async (data, resolve, reject) => {
  if (pageData) {
    resolve(pageData)
    return
  }
  try {
    const params = {
      args: {
        dchn: getUrlParams().dchn,
      }
    }
    // 纯csr模式下才去获取pid
    if (!__isServerRender__) {
      const prodKey = getUrlParams().prod_key
      const fpUid = await getFpUid()
      setPubData('uid_web', fpUid)
      const xTestUser = {
        key: fpUid // 用户标识
      }
      let extraArg = null
      if (prodKey === 'ut-integrated-lottery') {
          extraArg = await getArg()
      }
      params.args.runtime_args = { xTestUser, ...extraArg, pid: fpUid }
    }
    pageData = await webxGetPageConfig(params, process.env.WEBX_ENV)
    const xak = pageData?.conf?.x_act_key
    setPubData('xak', xak)
    const outerTitle = pageData?.conf?.strategy_data?.data?.game_info?.outer_title
    setPubData('outerTitle', outerTitle)
    const prizeData = pageData?.conf?.strategy_data?.data?.game_info?.prize_pool?.[0]?.groups
    setPubData('prizeData', prizeData)
    const xconfData = pageData?.conf?.x_test_list || []
    const testGroup = {
      x_test: [], // 测试唯一标识
      x_test_group: [], // 测试组
      x_test_type: [], // 测试类型
      x_test_content: [] // 测试赤兔标识
    }
    xconfData.map((item) => {
      testGroup.x_test.push(item.x_test_key)
      testGroup.x_test_group.push(item.x_test_group_name)
      testGroup.x_test_type.push(item.x_test_type)
      testGroup.x_test_content.push(item.x_test_content)
    })
    setPubData('testGroup', testGroup)
    addAbTestParams(testGroup)
    resolve(pageData?.conf?.ext?.content_conf?.project_data || {})
  } catch (error) {
    const { errno, data } = error
    if (errno === 5001) {
      resolve(data?.ext?.content_conf?.exception_data || {})
    } else {
      reject(error)
    }
  }
}
// 活动详情（game_detail）
export const getArg = async () => {
    const gameDetail = {
        only_original_info: true,
        extra: {
            env: {},
          collection_params: {
                dchn: getUrlParams().dchn,
                uuid: getUrlParams().dsp_uuid,
                xpsid: getUrlParams().xpsid,
                lp_type: getUrlParams().lp_type || 'h5'
            }
        }
    }
    // webx风控api获取的风控参数
    const envInfo = await getEnvInfo({ forceLocate: false })
    // try {
    //     const { lat, lng, cityId } = await invokeEvent('getLocationInfo')
    //     gameDetail.city_id = cityId || ''
    //     gameDetail.lat = lat || ''
    //     gameDetail.lng = lng || ''
    // } catch (error) {
    //     // gameDetail.city_id = 1 // 临时测试需要
    //     console.log('获取定位信息失败：', error)
    // }
    gameDetail.extra.env = envInfo
    return gameDetail
}
